module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAALhJREFUOE+dkjEOQUEURc+lsCI2QyVRaIiORiIKCgWdqCRKpV1Ygz3oEZdJ5ic/zI+Y6d7knvdu7nsi8WyvgB7QkXRKaVQBroEhcAfako6fuiqwDuzDROABdCUdynASDALbNWAbLT+BvqRdAVeChcD2BhiEXsBIUqj5CcbpC2Acm00kLWX7DDQTIV2BlqRLhKfvQbOom+eDsVsjYfsmKYQSgvq2mtpj+e/vcLLWYTvvAGxnn9zPI38BU/heDZYhABMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/矢量智能对象.png
// module id = UG7c
// module chunks = 3